import config from '@/config'

const sounds = new Audio(config.publicPath + '/sounds-9.ogg')

class SoundEffect {
  constructor () {
    this.audio = sounds.cloneNode(true)

    this.spriteData = {
      pop1: { start: 0.135, length: 0.5 },
      pop2: { start: 1.194, length: 0.5 },
      pop3: { start: 2.173, length: 0.5 },
      pop4: { start: 3.158, length: 0.5 },
      pop5: { start: 4.407, length: 0.5 },
      pop6: { start: 5.737, length: 0.5 },
      pop7: { start: 7.104, length: 0.5 },
      pop8: { start: 8.021, length: 0.5 },
      pop9: { start: 8.778, length: 0.5 },
      pop10: { start: 9.690, length: 0.5 },
      pop11: { start: 10.675, length: 0.5 },
      beep: { start: 12, length: 1 },
      wrong: { start: 14, length: 0.5 },
      correct: { start: 15, length: 2 }
    }

    this.currentSprite = {}

    this.audio.addEventListener('timeupdate', () => {
      if (this.audio.currentTime >= this.currentSprite.start + this.currentSprite.length) {
        this.audio.pause()
      }
    }, false)
  }

  play (id, rate = 1) {
    if (this.spriteData[id] && this.spriteData[id].length) {
      this.currentSprite = this.spriteData[id]
      this.audio.currentTime = this.currentSprite.start
      this.audio.playbackRate = rate
      this.audio.play()
    }
  }
}

export default SoundEffect
